const initialCollectionColumns = [
  { label: 'Sex:', column: 'sex' },
  { label: 'Collection type:', column: 'type' },
  { label: 'Body part:', column: 'body_part_examined' },
  { label: 'Imaging modality:', column: 'imaging_modality' },
  { label: 'Dataset type:', column: 'data_categories' },
  { label: 'Access type:', column: 'image_access_type' },
  { label: 'Supporting data:', column: 'supporting_data' },
  { label: 'Diagnosis:', column: 'diagnosis_available', rsql: 'diagnosis_available(label,uri,code)' },
  { label: 'Risk factors:', column: 'risk_factors' },
  { label: 'Treatment:', column: 'treatment' }
]

module.exports = initialCollectionColumns
